var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-app',[_c('header-component'),_c('v-container',{staticClass:"main-container"},[_c('v-row',[_c('v-col',[_c('router-view')],1)],1)],1),_c('footer-component')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }